import '../style/months-select.scss'
import { formatDate } from '../util'

export default {
  functional: true,
  render(h, context) {
    const { data = [], handleEvent, maxHeight } = context.props
    if (!Array.isArray(data)) {
      return null
    }
    const wrapStyle = maxHeight ? { maxHeight } : { maxHeight: '259px' }
    return (
      <div class="kye-date-picker3-month-selected" style={wrapStyle}>
        <div class="title">
          已选（<span style={{ color: data.length ? '#DB5500' : '#555961' }}>{data.length}</span>）项
        </div>
        {data.length ? (
          <div class="wrap">
            {data.reduce((acc, val, index) => {
              // const { label } = item || {}
              if (val) {
                acc.push(
                  <div class="item">
                    <span class="label">{formatDate(val, 'yyyy-MM')}</span>
                    <i class="close el-icon- btn" on-click={() => handleEvent('delete', { data, val, index })}></i>
                  </div>
                )
              }
              return acc
            }, [])}
          </div>
        ) : (
          <div class="empty">
            <i class="empty-icon"></i>
            <span>暂无选项</span>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker3/src/basic/months-select.js